import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import { CloseCircleIcon } from '../../../../assets/icons/svgicons';
import styles from "./Modal.module.scss";


const Modal = ({ show, handleClose, variant, cancelText, className, handleCancel, title, children, hideCloseBtn, backdropclass, ...rest }) => {
    return (
        <BootstrapModal
            {...rest}
            centered
            show={show}
            onHide={handleClose}
            data-variant={variant}
            className={`${styles.modal} ${className || ""}`}
            backdropClassName={backdropclass}
        >
            {title &&
                <BootstrapModal.Header className={!handleCancel && !hideCloseBtn ? "header-title" : "btn-back"}>
                    <h4>{title}</h4>
                    {hideCloseBtn &&
                        <button onClick={handleClose} className={`btn-close ${styles.close_btn}`}>
                            <CloseCircleIcon />
                        </button>
                    }
                    {
                        handleCancel &&
                        <button
                            className={styles.cancel_btn}
                            onClick={handleCancel}
                        >
                            {cancelText || "Cancel"}
                        </button>
                    }
                </BootstrapModal.Header>
            }
            <BootstrapModal.Body>
                {children}
            </BootstrapModal.Body>
        </BootstrapModal>
    )
}

export default Modal
